import { Schema as S } from "effect";

export const FeaturesConfig = S.Struct({
	paymentsEnabled: S.Boolean,
	/** Server half of the a2a-context gate; an older server omits it, which reads as off. */
	a2aContextEnabled: S.optionalKey(S.Boolean),
});
export type FeaturesConfig = typeof FeaturesConfig.Type;
